<script setup lang="ts">
import { ref, computed, onMounted } from 'vue'
import { officeType, departmentType } from '@/types/requests/userRoleSearchForm'
import SelectRoleChecker from '@/router/selectRoleChecker'
import { DEPARTMENT } from "@/services/consts/user_role";
import i18n from '@/lang/i18n';

const localIsDepartment = ref(false)
const organization_id = ref()

const emits = defineEmits([
  'update:modelValue'
])
const props = defineProps<{
  modelValue: departmentType
  organization: officeType
  errorMessages: string[]
  clearable: boolean
  isEdit: boolean
  isDepartment: boolean
}>()

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits('update:modelValue', value);
  },
})

const isReadonly = computed(() => {
  return props.isEdit
})

onMounted(() => {
  const current_role = SelectRoleChecker.getCurrentRole()
  let organization_type = ""
  if (current_role?.organization_id) {
    organization_id.value = current_role.organization_id
  }
  if (current_role?.organization_type) {
    organization_type = current_role.organization_type
  }
  if (organization_type == DEPARTMENT.type) {
    localIsDepartment.value = true
  }
})

const selectableDepartment = computed(() => {
  if (!props.organization || !props.organization.departments.length) {
    return []
  }
  let departments = [] as departmentType[]

  if (localIsDepartment.value) {
    departments = setSelectableDepartmentsWithDepartmentId()
  } else {
    departments = setSelectableDepartments()
  }
  return departments
})

function setSelectableDepartmentsWithDepartmentId(){
  let departments = [] as departmentType[]

  props.organization.departments.forEach((department) => {
    if (
      organization_id.value == department.id ||
      organization_id.value == department.parent_id
    ) {
      departments.push({
        id: department.id,
        operation_office_id: department.operation_office_id,
        name: department.name,
      })
    }
  })

  if(!props.isEdit && localIsDepartment.value && departments.length == 1){
    modelValue.value = departments[0]
  }
  return departments
}

function setSelectableDepartments(){
  let departments = [] as departmentType[]

  props.organization.departments.forEach((department) => {
    departments.push({
      id: department.id,
      operation_office_id: department.operation_office_id,
      name: department.name,
    })
  })
    if (!props.isEdit && localIsDepartment.value && departments.length == 1) {
      modelValue.value = departments[0]
    }
  return departments
}

</script>
<template>
  <v-select
    class="mb-2"
    v-model="modelValue"
    :items="selectableDepartment"
    item-title="name"
    item-value="id"
    :label="i18n.global.t('pages.userRoles.search.department')"
    v-bind="{'return-object': true}"
    :readonly="isReadonly"
    :clearable="clearable"
    :error-messages="errorMessages"
  />
</template>
